import { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/hooks/useStores';
import { lazyRoute } from '@/routing/lazyRoute';

const ItemArchiveToast = lazyRoute(
  () => import('./ItemArchiveToast'),
  (module) => module.ItemArchiveToast,
);

/**
 * Where `ItemArchiveToast` mounts (`Layout.tsx`), loaded only once an archive has raised a toast,
 * so the launch entry carries the store and none of the `workItems` words its failure says.
 */
export const ItemArchiveToastSlot = observer(function ItemArchiveToastSlot() {
  const { itemArchiveToastStore } = useStores();
  if (!itemArchiveToastStore.toast) return null;
  return (
    <Suspense fallback={null}>
      <ItemArchiveToast />
    </Suspense>
  );
});
